export const GET_SURVEY = "GET_SURVEY"
export const GET_SURVEY_SUCCESS = "GET_SURVEY_SUCCESS"
export const GET_SURVEY_FAILED = "GET_SURVEY_FAILED"

export const UPDATE_PLACES_FORM = "UPDATE_PLACES_FORM"
export const UPDATE_PLACES_FORM_SUCCESS = "UPDATE_PLACES_FORM_SUCCESS"
export const UPDATE_PLACES_FORM_FAILED = "UPDATE_PLACES_FORM_FAILED"

export const GET_PLACES_MENU_ITEM = "GET_PLACES_MENU_ITEM"
export const GET_PLACES_MENU_ITEM_SUCCESS = "GET_PLACES_MENU_ITEM_SUCCESS"
export const GET_PLACES_MENU_ITEM_FAILED = "GET_PLACES_MENU_ITEM_FAILED"

export const RESET_PLACES_MENU_ITEM = "RESET_PLACES_MENU_ITEM"
